import { 
    Box,
    Divider,
} from '@mui/material';
import {
    DeleteButton,
    EditButton,
    ShowButton,
    useRecordContext,
    Button,
} from 'react-admin';
import {
    useCreatePath,
} from 'ra-core';
import { Link } from 'react-router-dom';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

import { useLocation } from 'react-router';
import { User } from '@/types';

export const UserAside = ({ link = 'edit' }: { link?: 'edit' | 'show' }) => {
    const location = useLocation();
    const record = useRecordContext<User>();
    if (!record) return null;

    const createPath = useCreatePath();
    const stopPropagation = (e: any) => e.stopPropagation();

    return (
        <Box ml={4} width={250} minWidth={250}>
            {link !== 'edit' ? (
                <></>
            ) : (
                <>
                    <Box my={2}>
                        <Button
                            component={Link}
                            to={createPath({ resource: 'users', type: 'list' })}
                            label={'Back'}
                            onClick={stopPropagation}>
                            <ArrowBackIcon />
                        </Button>
                    </Box>
                    <Divider />
                </>
            )}
            <Box my={2}>
                {link === 'edit' ? (
                    <EditButton label="Edit User" />
                ) : (
                    <ShowButton label="Show User" />
                )}
                <br/>
                <DeleteButton mutationMode="pessimistic" redirect={location.state?.from || undefined} />
            </Box>
        </Box>
    );
};
